import { formatDate, parseString } from './helpers'

export interface PartnerInterface {
  id: string
  code: string
  type: string
  name: string
  description: string
  created_at: string | null
  updated_at: string | null
  deleted_at: string | null
}

export interface PartnerResponseInterface {
  id: string
  code: string
  type: string
  name: string
  description: string
  created_at: string | null
  updated_at: string | null
  deleted_at: string | null
}

export function parsePartnerModel(response: PartnerResponseInterface): PartnerInterface {
  return {
    id: parseString(response?.id),
    code: parseString(response?.code),
    type: parseString(response?.type),
    name: parseString(response?.name),
    description: parseString(response?.description),
    created_at: formatDate(response?.created_at) || null,
    updated_at: formatDate(response?.updated_at) || null,
    deleted_at: formatDate(response?.deleted_at) || null,
  }
}
